/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Show grid</h4>

<p>Show or hide a grid for snapping onto.</p>`;

export default function ToggleGridTooltip() {
    return h('div', { innerHTML: body });
}
